import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDScGameResult implements ICommand
{

	public FGameID : bigint = 0n; 
	public GameID : number = 0;
	public FGameResult : bigint = 0n; 
	public GameResult : number = 0;
	public ResultString : string = "";

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.FGameID = ba.readUint64();
		this.GameID = Number(this.FGameID);
		this.FGameResult = ba.readUint64();
		this.GameResult = Number(this.FGameResult);
		this.ResultString = ba.readString();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint64(this.FGameID);
		ba.writeUint64(this.FGameResult);
		ba.writeString(this.ResultString);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDScGameResult();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'GameID(F)='+this.GameID+' ';
		str += 'GameResult(F)='+this.GameResult+' ';
		str += 'ResultString(S)='+this.ResultString+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 30006;
	}

	public getCmdName() : string
	{
		return 'ScGameResult';
	}

}
